/* @flow */

import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';

import { customMenuPlugin } from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getCustomMenuLinks(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[customMenuPlugin];

  if (options) {
    assertObject(options, 'options');

    return options.links || [];
  }
}
